import axios from '../../../../../../api/axios';

export const fetchingUserData = async (userId) => {
  try {
    const { data: freight } = await axios.get(
      `/api/v1/admin/users/freight/${userId}`
    );
    return freight;
  } catch (error) {
    return error;
  }
};
export const fetchingOrders = async (userId, page = 1, limit = 5) => {
  try {
    const { data: orders } = await axios.get(
      `/api/v1/admin/freight/orders/list/byFreight/${userId}?page=${page}&limit=${limit}`
    );
    return orders;
  } catch (error) {
    return error;
  }
};
export const fetchingNotes = async (userId) => {
  try {
    const { data: notes } = await axios.get(
      `/api/v1/admin/users/${userId}/notes`
    );
    return notes;
  } catch (error) {
    return error;
  }
};
export const fetchingPhones = async (userId) => {
  try {
    const {
      data: { phones },
    } = await axios.get(`/api/v1/admin/users/freight/${userId}/phones/all`);
    return phones;
  } catch (error) {
    throw error;
  }
};
export const addNote = async (userId, note) => {
  try {
    const { data } = await axios.post(`/api/v1/admin/users/addNote`, {
      userId,
      note,
    });
    return data;
  } catch (error) {
    return error;
  }
};
export const deleteNote = async (noteId) => {
  try {
    const { data } = await axios.delete(
      `/api/v1/admin/users/deleteNote/${noteId}`
    );
    return data;
  } catch (error) {
    return error;
  }
};
